module.exports = __webpack_public_path__ + "img/Picture.6e7c4d8c.svg";